import { body1Styles, body2Styles, body3Styles } from "../../presets/typography";
import { colors } from "../../tokens/color";
export const pillStyles = {
    root: (isClickable, size, variant, hasLink) => ({
        borderRadius: '100px',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        display: 'inline-flex',
        gap: '0.6rem',
        alignItems: 'center',
        cursor: isClickable ? 'pointer' : undefined,
        '&:not([data-selected]):not([data-disabled]):hover': isClickable || hasLink
            ? {
                primaryFilled: {
                    boxShadow: `inset 0 0 0 1px ${colors.border.activePrimary}`,
                },
                primaryOutline: {
                    boxShadow: `inset 0 0 0 1px ${colors.border.activeSecondary}`,
                    color: colors.text.activeSecondary,
                },
                secondaryFilled: {
                    boxShadow: `inset 0 0 0 1px ${colors.border.secondary}`,
                },
                secondaryOutline: {
                    boxShadow: `inset 0 0 0 1px ${colors.border.secondary}`,
                },
                inverseFilled: {
                    backgroundColor: colors.background.medium,
                },
                inverseOutline: {
                    boxShadow: `inset 0 0 0 1.5px ${colors.border.inversePrimary}`,
                },
            }[variant]
            : undefined,
        border: 'none',
        transition: 'background-color 300ms ease, box-shadow 300ms ease, color 300ms ease',
        padding: {
            small: '6px 8px',
            medium: '10px 16px',
            large: '14px 20px',
        }[size],
        '&[data-disabled]': {
            pointerEvents: 'none',
            ...{
                primaryFilled: {
                    color: colors.text.disabled,
                    background: colors.action.disabled,
                },
                primaryOutline: {
                    boxShadow: `inset 0 0 0 1px ${colors.border.disabled}`,
                    color: colors.text.disabled,
                },
                secondaryFilled: {
                    color: colors.text.disabled,
                    background: colors.action.disabled,
                },
                secondaryOutline: {
                    boxShadow: `inset 0 0 0 1px ${colors.border.disabled}`,
                    color: colors.text.disabled,
                    background: colors.action.disabled,
                },
                inverseFilled: {
                    color: colors.text.disabled,
                    background: colors.action.disabled,
                },
                inverseOutline: {
                    boxShadow: `inset 0 0 0 1px ${colors.border.disabled}`,
                    color: colors.text.disabled,
                },
            }[variant],
        },
        outlineOffset: '2px',
        '&:focus-visible': {
            primaryFilled: {
                outline: `1px solid ${colors.border.activePrimary}`,
            },
            primaryOutline: {
                outline: `1px solid ${colors.border.activePrimary}`,
            },
            secondaryFilled: {
                outline: `1px solid ${colors.border.activePrimary}`,
            },
            secondaryOutline: {
                outline: `1px solid ${colors.border.activePrimary}`,
            },
            inverseFilled: {
                outline: `1px solid ${colors.border.inversePrimary}`,
            },
            inverseOutline: {
                outline: `1px solid ${colors.border.inversePrimary}`,
            },
        }[variant],
        backgroundColor: {
            primaryFilled: colors.action.active,
            primaryOutline: colors.background.white,
            secondaryFilled: colors.background.lighter,
            secondaryOutline: colors.background.white,
            inverseFilled: colors.background.white,
            inverseOutline: colors.transparent,
        }[variant],
        boxShadow: {
            primaryFilled: undefined,
            primaryOutline: `inset 0 0 0 1px ${colors.border.activePrimary}`,
            secondaryFilled: undefined,
            secondaryOutline: `inset 0 0 0 1px ${colors.border.primary}`,
            inverseFilled: undefined,
            inverseOutline: `inset 0 0 0 1px ${colors.border.inversePrimary}`,
        }[variant],
        color: {
            primaryFilled: colors.text.activeSecondary,
            primaryOutline: colors.text.activePrimary,
            secondaryFilled: colors.text.secondary,
            secondaryOutline: colors.text.secondary,
            inverseFilled: colors.text.secondary,
            inverseOutline: colors.text.inversePrimary,
        }[variant],
        ...{
            small: {
                fontSize: body3Styles.fontSize,
                fontFamily: body3Styles.fontFamily,
            },
            medium: {
                fontSize: body2Styles.fontSize,
                fontFamily: body2Styles.fontFamily,
            },
            large: {
                fontSize: body1Styles.fontSize,
                fontFamily: body1Styles.fontFamily,
            },
        }[size],
        '&[data-selected]:not([data-disabled])': {
            primaryFilled: {
                backgroundColor: colors.action.innovation,
                color: colors.text.inversePrimary,
            },
            primaryOutline: {
                boxShadow: `inset 0 0 0 1px ${colors.border.activePrimary}`,
                color: colors.text.activeSecondary,
                backgroundColor: colors.action.active,
            },
            secondaryFilled: {
                color: colors.text.inversePrimary,
                backgroundColor: colors.background.darker,
            },
            secondaryOutline: {
                backgroundColor: colors.background.lighter,
            },
            inverseFilled: {
                backgroundColor: colors.action.innovation,
                color: colors.text.inversePrimary,
            },
            inverseOutline: {
                boxShadow: `inset 0 0 0 1px ${colors.action.curveLogicLight}`,
                color: colors.text.inverseActiveSecondary,
            },
        }[variant],
    }),
    removeButton: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        color: 'inherit',
        fontSize: 'inherit',
        '&:focus-visible': {
            outline: '1px solid currentColor',
            outlineOffset: '2px',
        },
        borderRadius: '100%',
    },
    iconWrapper: {
        display: 'inline-flex',
        '& > svg': {
            height: '1em',
            width: '1em',
            '& > path': {
                fill: 'currentColor',
            },
        },
    },
    label: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    },
    linkLabel: {
        textDecoration: 'none',
        color: 'inherit',
        borderRadius: '2px',
        '&:focus-visible': {
            outline: '1px solid currentColor',
            outlineOffset: '2px',
        },
    },
};
